// extracted by mini-css-extract-plugin
export var political_ed_card = "PoliticalEdCard-module--political_ed_card--5cLdM";